export const createActiveAnalysisJob = () => {
  let activeJobId: string | undefined;

  return {
    activate(jobId?: string) {
      if (!jobId) {
        return;
      }
      activeJobId = String(jobId);
    },
    is(jobId: string) {
      return activeJobId === String(jobId);
    }
  };
};
